import { render } from "./CallForPapersView.vue?vue&type=template&id=ffc3def8"
import script from "./CallForPapersView.vue?vue&type=script&lang=js"
export * from "./CallForPapersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__